// Central site configuration
// Configure the canonical site URL via VITE_SITE_URL environment variable
export const SITE_URL = 
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 
  process.env.VITE_SITE_URL || 
  'https://example.com';